'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Divtable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_divtable',
		zebring: true,
		zebra_order: 'even', //even or odd
		zebra_class: 'x',
		sortable: false,
		animate_on_sort: true,
		no_data_char: '-',
		first_sort: 'desc'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.w_divtable');

		if (this._element) this.build();
	},

	build: function build() {
		var opts = this.opts = this.options;
		this._thead = this._element.getElement('.thead');
		this._tbody = this._element.getElement('.tbody');
		this._trs = this._tbody.getElements('.tr');

		this.first_sort = this.options.first_sort;
		this.second_sort = this.options.first_sort == 'desc' ? 'asc' : 'desc';

		if (this._trs.length > 500) {
			opts.animate_on_sort = false;
		}

		if (opts.sortable) {
			this._element.addClass('sortable');
			this.trs = []; //array of objects for sorting

			this._trs.each(function (_el) {
				this.trs.push({
					element: _el
				});
			}.bind(this));

			if (opts.sortable && this._trs.length > 1) {
				this.get_sorting_togglers();
			}
		}

		if (opts.zebring == true) {
			this.zebring();
		}

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('_touch');
		}

		this.linking();

		this.add_tr_events();
	},

	add_new_rows: function add_new_rows(rows) {
		var even_or_odd = this._trs.length % 2;

		if (rows && rows.length > 0) {
			rows.each(function (_el) {
				if (!this._trs) {
					this._trs = [];
				}

				this._trs.push(_el);

				if (this.trs) {
					this.trs.push({
						element: _el
					});
				}
			}.bind(this));

			if (this.opts.zebring == true) {
				this.zebring(rows, even_or_odd);
			}

			this.linking(rows);
			this.sorted = false;
		}
	},

	zebring: function zebring(rows, even_or_odd) {
		var opts = this.options,
		    order = 0;

		if (!even_or_odd || even_or_odd == 0) {
			order = opts.zebra_order == 'odd' ? 1 : 0;
		} else {
			order = opts.zebra_order == 'odd' ? 0 : 1;
		}

		var _rows = rows && rows.length > 0 ? rows : this._trs;

		_rows.each(function (_el, i) {
			i = i + order;

			if (i % 2 == 0) {
				_el.removeClass(opts.zebra_class);
			} else {
				_el.addClass(opts.zebra_class);
			}
		});
	},

	linking: function linking(_trs) {
		var _rows = _trs || this._trs;

		_rows.each(function (_el) {
			var href = _el.getAttribute('data-href');

			if (!href || href == '') return;

			var _photo = _el.getElement('.photo');

			if (!_photo) {
				_el.addClass('link');
				_el.addEvent('click', function () {
					window.location = href;
				});
				return;
			}

			_photo = _photo.getElement('.lst_photo') || _photo;

			_photo.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (e.shift || e.control || e.meta || e.alt) {
					var _temp_a = new Element('a', {
						target: "_blank",
						href: href,
						styles: {
							display: "none"
						}
					}).inject(_photo.getParent());

					var custom_event = document.createEvent('MouseEvents');

					custom_event.initMouseEvent('click', true, true, window);
					_temp_a.dispatchEvent(custom_event);
					_temp_a.destroy();
				} else {
					window.location = href;
				}
			});
		});
	},

	get_sorting_togglers: function get_sorting_togglers() {
		if (!this._thead) return;

		this._sorters = this._thead.getElements('.th[data-sort]');

		if (this._thead.hasClass('dropdown')) {
			this.create_dropdown();
		}

		this._sorters.each(function (_el) {
			if (!_el.getElement('.sort_span')) {
				_el.set('html', _el.get('html') + '<span class="sort_span">&nbsp;</span>');
			}

			var data_sort = _el.getAttribute('data-sort');
			data_sort = data_sort.toLowerCase();

			if (data_sort != '') {
				if (!_el.hasClass('.sort')) {
					_el.addClass('sort unsorted');
				}

				_el.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					_el.removeClass('unsorted');

					this.order = this.first_sort;

					if (_el.hasClass(this.first_sort)) {
						_el.removeClass(this.first_sort);
						_el.addClass(this.second_sort);
						this.order = this.second_sort;
					} else if (_el.hasClass(this.second_sort)) {
						_el.removeClass(this.second_sort);
						_el.addClass(this.first_sort);
					} else {
						_el.addClass(this.first_sort);
						this.sorted = false;
					}

					this.sort(data_sort);

					if (this._prev_sorter && this._prev_sorter != _el) {
						this._prev_sorter.removeClass(this.first_sort);
						this._prev_sorter.removeClass(this.second_sort);
						this._prev_sorter.addClass('unsorted');
					}

					this._prev_sorter = _el;
					this.fireEvent('sorting', [_el]);
				}.bind(this));
			}
		}.bind(this));
	},

	before_sort: function before_sort(sort) {
		this.compare_strings = false;

		this.trs.each(function (_el) {
			var data = 'data-' + sort;
			var value = _el.element.getAttribute(data);

			if (_el.element.getStyle('display') == 'none') {
				this.trs_nottosort.push(_el);
			} else {
				if (!value || value == '' || value == this.opts.no_data_char) {
					this.trs_nottosort.push(_el);
				} else {
					if (value.toFloat()) {
						_el.value = value.toFloat();
					} else {
						_el.value = value;
						this.compare_strings = true;
					}

					this.trs_tosort.push(_el);
				}
			}
		}.bind(this));
	},

	sort: function sort(_sort) {
		var opts = this.options;

		if (!this.sorted) {
			//do not sort if array has been just sorted with this sorter
			this.trs_length = this.trs.length;

			this.trs_tosort = [];
			this.trs_nottosort = [];
			this.before_sort(_sort);

			this.quick_sort(0, this.trs_tosort.length - 1, _sort);

			this.sorted = true;
		}

		var temp_array;
		if (this.order == 'asc') {
			temp_array = Array.clone(this.trs_tosort);
			this.trs = temp_array.append(this.trs_nottosort);
		} else {
			temp_array = Array.clone(this.trs_nottosort);
			this.trs = temp_array.append(this.trs_tosort);
		}

		this._tbody.empty();

		if (opts.animate_on_sort) {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_zebring_animate(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_simple_animate(_el.element, i);
				}.bind(this));
			}
		} else {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					this.insert_element_zebring(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el) {
					this.insert_element_simple(_el.element);
				}.bind(this));
			}
		}
	},

	insert_element_zebring: function insert_element_zebring(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		}
	},

	insert_element_zebring_animate: function insert_element_zebring_animate(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	insert_element_simple: function insert_element_simple(_el) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}
	},

	insert_element_simple_animate: function insert_element_simple_animate(_el, i) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}

		if (this.order == 'desc') {
			i = this.trs_length - 1 - i;
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.trs_tosort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.trs_tosort[left].value + '' <= center.value + '') {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value + '' > center.value + '') {
						right--;
					}
				} else {
					while (left <= right && this.trs_tosort[left].value <= center.value) {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value > center.value) {
						right--;
					}
				}

				if (left < right) {
					temp = this.trs_tosort[right];
					this.trs_tosort[right] = this.trs_tosort[left];
					this.trs_tosort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.trs_tosort[right];
			this.trs_tosort[right] = this.trs_tosort[first];
			this.trs_tosort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	create_dropdown: function create_dropdown() {
		this._thead.clone().inject(this._thead, 'after');

		this._sort_display = new Element('.sort_display');
		this._sort_display.inject(this._thead, 'top');

		this._thead.removeClass('thead').addClass('styled_select fake');

		new Element('.clearfix').inject(this._element, 'before').adopt(this._thead);

		this._sorters.each(function (_el) {
			var value = _el.getAttribute('data-value');

			if (value && value != '') {
				_el.set('html', value);
			}

			_el.setProperty('class', 'dropdown_item');

			var data_sort = _el.getAttribute('data-sort');

			if (!data_sort || data_sort == '') {
				_el.dispose();
			}
		});

		this._sort_display.set('html', this._sorters[0].get('html'));

		this._list = this._thead.getElement('.tr').removeClass('tr').addClass('dropdown_list');

		this._list.setStyle('visibility', 'hidden');
		this.dd_height = this._list.getSize().y;
		this._list.setStyle('height', 0);

		this.dd_fx = new Fx.Morph(this._list, { duration: 100, link: 'cancel' });

		this._list.setStyle('visibility', 'visible');

		this._list.setStyle('bottom', this._list.getCoordinates().y * -1);

		this.add_dropdown_behavior();
	},

	add_dropdown_behavior: function add_dropdown_behavior() {
		this._sort_display.addEvents({
			'click': this.toggle_dropdown.bind(this)
		});

		this._sorters.each(function (_el) {
			_el.addEvent('click', function () {
				this.toggle_dropdown();
				this._sort_display.set('html', _el.get('html'));
			}.bind(this));
		}.bind(this));

		$(document.body).addEvent('click:relay(div)', function (e, _element) {
			if (this._sort_display !== _element) {
				this.toggle_dropdown(0);
			}
		}.bind(this));
	},

	toggle_dropdown: function toggle_dropdown(height) {
		if (height == 0 || this._list.getSize().y > 0) {
			this.dd_fx.start({ 'height': 0 });
		} else {
			this.dd_fx.start({ 'height': this.dd_height });
		}
	},

	reinitialize: function reinitialize() {
		if (this._sorters) {
			this._sorters.each(function (_el) {
				_el.removeEvents();
			});

			this._prev_sorter = this._thead.getElement('.asc') || this._thead.getElement('.desc');
		}

		this.initialize();
	},

	add_tr_events: function add_tr_events() {
		var self = this;
		var _current_tr;
		var _current_el;

		if (Core.is_touch_supported()) {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_current_el && _current_el !== _el) {
							_current_el.removeClass('_active');
						}

						_current_el = _el;
					}
				});

				$(document.body).addEvents({
					'touchstart:relay("*")': function touchstartRelay(e, _el) {
						if (!_el || _el != self._element && !_el.getParent('.w_divtable')) {
							if (typeof _current_el !== 'undefined' && _current_el) {
								_current_el.removeClass('_active');
							}
						}
					}
				});
			});
		} else {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click(e) {
						if (_el.get('data-href')) {
							//stop when user clicked an anchor element
							if (e && e.target && (e.target.get('href') || e.target.getParent().get('href'))) return;

							window.location = _el.get('data-href');
						}
					},
					'mouseover': function mouseover() {
						if (_current_tr && _current_tr !== _el) {
							_current_tr.removeClass('_active');
						}

						_el.addClass('_active');

						_current_tr = _el;
					},

					'mouseleave': function mouseleave() {
						_el.removeClass('_active');
					}
				});
			});
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Rater = new Class({
	Implements: [Events, Options],
	options: {
		max_size: 0, //height or width
		min_size: 0, //height or width === don't need to specify, if 'size' in this options is absolute
		max_data: 0, //max value through the elements === optional
		min_data: 0, //min value through the elements === optional
		property: 'data-height', //property of the elements where to take data
		animate: true,
		duration: 500,
		equal_speed: true, //if false, all animations will finish at the same time (duration),
		//if true, the speed for each animation is the same, so the smallest element will finish first
		transition: Fx.Transitions.linear,
		type: 'vertical', //vertical or horisontal
		size: 'absolute', //absolute or relative
		//IMPORTANT!: don't use 'relative' sizing if there is a possibility of negative values !!!!!!!!!!!!
		//if absolute, the size of each element counts from 0
		//i.e. - max_size is 100px,
		//and you have 5 elements with 'data-height's {20, 40, 60, 80, 100},
		//so, their sizes are going to be - {20, 40, 60, 80, 100}.
		//if relative, the size of each element counts from min_height
		//i.e. - max_size is 100px, min_size is 60px, and you have the same elements,
		//so, their sizes are going to be - {60, 70, 80, 90, 100}
		calculate_even_one_element: false //can be helpful when you use lazyLoader (in this case set to 'true')
	},

	initialize: function initialize(_elements, options) {
		this._elements = _elements;

		if (this._elements) {
			this.setOptions(options);
			this.build();
		}
	},

	build: function build() {
		var opts = this.options;

		if (this._elements.length == 0 || this._elements.length == 1 && !opts.calculate_even_one_element) return;

		this.max_data = opts.max_data;
		this.min_data = opts.min_data;
		this.has_negative = this.max_data < 0 || this.min_data < 0;

		if (opts.type == 'vertical') {
			this.max_size = opts.max_size == 0 ? this._elements[0].getSize().y : opts.max_size;
		} else {
			this.max_size = opts.max_size == 0 ? this._elements[0].getSize().x : opts.max_size;
		}

		if (this.max_size > 0) {
			opts.max_size = this.max_size;

			if (opts.animate == true) {
				if (opts.type == 'vertical') {
					this._elements.each(function (_el) {
						_el.setStyle('height', 0);
					});
				} else {
					this._elements.each(function (_el) {
						_el.setStyle('width', 0);
					});
				}
			}

			if (!this.max_data || this.max_data == 0) {
				this.get_values();
			}

			if (!(this.max_data == 0 && this.min_data == 0)) {
				this.calculate_size();
				this.set_size();
			}
		}
	},

	get_values: function get_values() {
		this._elements.each(function (_el) {
			var data = _el.getAttribute(this.options.property).toFloat() || 0;

			if (data > this.max_data) {
				this.max_data = data;
			}

			if (this.min_data > data || this.min_data == 0) {
				this.min_data = data;
			}

			if (data < 0) {
				this.has_negative = true;
			}
		}.bind(this));
	},

	calculate_size: function calculate_size() {
		var opts = this.options;

		if (this.options.size == 'relative') {
			var data_diff = this.max_data - this.min_data,
			    size_diff = opts.max_size.toInt() - opts.min_size.toInt();

			this._elements.each(function (_el) {
				var data = _el.getAttribute(opts.property).toFloat(),
				    this_size = opts.max_size;

				if (data_diff > 0) {
					this_size = opts.min_size + (data - this.min_data) * size_diff / data_diff;
				}

				_el.setAttribute('data-size', this_size);
			}.bind(this));

			if (this.min_data < 0) {
				console.warn("Don't use 'relative' sizing with negative values!");
			}
		} else {
			if (this.max_data > 0 && this.min_data >= 0) {
				this._elements.each(function (_el) {
					var data = _el.getAttribute(opts.property).toFloat();
					data = data > this.max_data ? this.max_data : data;

					var this_size = data * opts.max_size / this.max_data;

					_el.setAttribute('data-size', this_size);
				}.bind(this));
			} else if (this.max_data <= 0 && this.min_data < 0) {
				this._elements.each(function (_el) {
					var data = _el.getAttribute(opts.property).toFloat();
					data = data > this.max_data ? this.max_data : data;

					var this_size = data * opts.max_size / this.min_data * -1;

					_el.setAttribute('data-size', this_size);
				}.bind(this));
			} else if (this.max_data > 0 && this.min_data < 0) {
				var count_data = this.max_data + this.min_data * -1,
				    shift = this.min_data * opts.max_size / count_data * -1;

				if (opts.type == 'vertical') {
					this._elements.each(function (_el) {
						var _parent = _el.getParent();
						_parent.setStyle('height', _parent.getSize().y - shift);

						var data = _el.getAttribute(opts.property).toFloat();
						data = data > this.max_data ? this.max_data : data;

						var this_size = data * opts.max_size / count_data;

						_el.setAttribute('data-size', this_size);
					}.bind(this));
				} else {
					this._elements.each(function (_el) {
						var _parent = _el.getParent();

						_parent.setStyles({
							'margin-left': shift,
							'width': _parent.getSize().x - shift
						});

						var data = _el.getAttribute(opts.property).toFloat();
						data = data > this.max_data ? this.max_data : data;

						var this_size = data * opts.max_size / count_data;

						_el.setAttribute('data-size', this_size);
					}.bind(this));
				}
			}
		}
	},

	set_size: function set_size() {
		var _this = this;
		var opts = this.options;

		if (this.has_negative) {
			opts.animate = false;

			if (this.max_data <= 0) {
				this._elements.each(function (_el) {
					var _parent = _el.getParent();

					if (opts.type == 'vertical') {
						_parent.setStyle('height', 'auto');
					}
				}.bind(this));
			}
		}

		if (opts.animate == true) {
			this._elements.each(function (_el) {
				var size = _el.getAttribute('data-size').toFloat(),
				    this_time = opts.equal_speed == true ? size * opts.duration / opts.max_size : opts.duration,
				    animate = new Fx.Morph(_el, { duration: this_time, transition: opts.transition });

				if (opts.type == 'vertical') {
					animate.start({ 'height': [0, size] });
				} else {
					animate.start({ 'width': [0, size] });
				}

				(function () {
					animate = null;
				}).delay(this_time);
			});

			(function () {
				_this.fireEvent('animationDone');
			}).delay(opts.duration);
		} else {
			this._elements.each(function (_el) {
				var size = _el.getAttribute('data-size').toFloat(),
				    shift = 0;

				if (size < 0) {
					shift = size;
					size *= -1;
				}

				if (opts.type == 'vertical') {
					_el.setStyles({
						'height': size,
						'bottom': shift
					});
				} else {
					_el.setStyles({
						'width': size,
						'left': shift
					});
				}
			});
		}

		this.fireEvent('sizeSet');
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.1: '*'
...
*/
var FilterTable = new Class({
	Implements: [Options, Events],

	options: {
		table: null
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);

		this._element = element;

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		this._date_from = this._element.getElement('#date_from');
		this._date_to = this._element.getElement('#date_to');
		this._rooms = this._element.getElement('#rooms_filter');
		this._show_all = this._element.getElement('.show_all');
		this.max_rooms = this._rooms.getLast('option').get('text').toInt();

		this.date_pickers = [];
		this.count = 0;

		this._table = this.options.table || document.getElement('.w_divtable'), this._rows = this._table.getElement('.tbody').getElements('.tr');
		this._for_show_room = [];
		this._for_show_date_min = [];
		this._for_show_date_max = [];

		if (this._date_from) {
			this.create_datepicker(this._date_from);
		}

		if (this._date_to) {
			this.create_datepicker(this._date_to);
		}

		if (this._rows.length > 1) {
			this._rooms.addEvent('change', function () {
				this.filter();
			}.bind(this));
			this._date_from.addEvent('change', function () {
				this.filter();
			}.bind(this));
			this._date_to.addEvent('change', function () {
				this.filter();
			}.bind(this));
			this._show_all.addEvent('click', function (e) {
				e.preventDefault();this.show_all();
			}.bind(this));
		}
	},

	create_datepicker: function create_datepicker(_element) {
		var self = this;
		var min = Core.get_daterange_min_date(this._element.get('data-type'));
		var max = Core.get_daterange_max_date();

		this.date_pickers[this.count] = new Picker.Date(_element, {
			timePicker: false,
			draggable: false,
			minDate: min,
			maxDate: max,
			pickOnly: 'days',
			pickerClass: 'datepicker_vista',
			format: "%m/%d/%Y",
			useFadeInOut: true,
			onSelect: function onSelect(dateText, input) {
				if (_element.get('id') === 'date_from') {
					self.date_pickers[1].options.minDate = dateText.increment('day', 1);
				} else {
					self.date_pickers[0].options.maxDate = dateText.decrement('day', 1);
				}
			}
		});

		this.count++;
	},

	show_all: function show_all() {
		this.reset_date_picker();

		this._rooms.getElement('option').set('selected', 'selected');
		this._date_from.set('value', 'MM/DD/YYYY');
		this._date_to.set('value', 'MM/DD/YYYY');
		this._show_all.removeClass('show');

		this.filter();
	},

	room_filter: function room_filter(value) {
		this._for_show_room = [];

		this._rows.each(function (e) {
			if (value == 'all') {
				this._for_show_room.push(e);
			} else {
				var this_value = e.getProperty('data-size');

				value = value.toInt();

				if (value == this.max_rooms) {
					if (this_value >= value) {
						this._for_show_room.push(e);
					}
				} else {
					if (this_value == value) {
						this._for_show_room.push(e);
					}
				}
			}
		}.bind(this));
	},

	date_filter_min: function date_filter_min(value) {
		this._for_show_date_min = [];

		if (value && value != '' && value != 'MM/DD/YYYY') {
			var cell_time = 0;

			this._for_show_room.each(function (e, i) {
				cell_time = e.getProperty('data-date');

				if (cell_time >= value) {
					this._for_show_date_min.push(e);
				}
			}.bind(this));
		} else {
			this._for_show_date_min = this._for_show_room;
		}
	},

	date_filter_max: function date_filter_max(value) {
		this._for_show_date_max = [];

		if (value && value != '' && value != 'MM/DD/YYYY') {
			var cell_time = 0;

			this._for_show_date_min.each(function (e) {
				cell_time = e.getProperty('data-date');

				if (cell_time <= value) {
					this._for_show_date_max.push(e);
				}
			}.bind(this));
		} else {
			this._for_show_date_max = this._for_show_date_min;
		}
	},

	reset_date_picker: function reset_date_picker() {
		this.date_pickers.each(function (date_picker) {
			date_picker.select(new Date());
		});
	},

	filter: function filter() {
		this._rows.each(function (e) {
			e.addClass('hidden');
		}.bind(this));

		var room_value = this._rooms.getElement(':selected').getProperty('data-show').toLowerCase(),
		    min_date = this._date_from.get('value'),
		    max_date = this._date_to.get('value');

		if (min_date && min_date != '' && min_date != 'MM/DD/YYYY') min_date = Date.parse(this._date_from.get('value')).format('%s');
		if (max_date && max_date != '' && max_date != 'MM/DD/YYYY') max_date = Date.parse(this._date_to.get('value')).format('%s');

		room_value = room_value.toLowerCase() == 'studio' ? 0 : room_value;

		this.room_filter(room_value);
		this.date_filter_min(min_date);
		this.date_filter_max(max_date);

		this._for_show_date_max.each(function (e) {
			e.removeClass('hidden');
		}.bind(this));
		this.fireEvent('endFilter', [this._for_show_date_max]);
	}
});
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Page.Bsr = new Class({
	Extends: Page,
	build: function build() {
		this.parent();
		this.get_stalker_info();
		this.fill_nav_title();

		this.set_sales_data();
		this.set_available_apts();
		this.set_similar_buildings();
		//this.set_floorplans();
		this.set_all_units();
		this.set_sell();
		this.set_contact();
		this.set_off_market_deals();

		var page_photogallery = document.id('photogallery_last_sale');
		if (page_photogallery) {
			new PagePhotogallery(page_photogallery);
		}

		var __zebring = function __zebring(e) {
			e.each(function (_el, i) {
				i % 2 != 0 ? _el.addClass('x') : _el.removeClass('x');
			});
		};

		var _divtable = document.getElement('.content_main .w_divtable');

		if (_divtable) {
			_divtable.store('instance', new Divtable(_divtable, {
				sortable: true,
				zebra_order: 'even'
			}));

			var _indicators = _divtable.getElements('.indicator');

			if (_indicators && _indicators.length > 0) {
				var _ref;

				new Rater(_indicators, (_ref = {
					'min_size': 20,
					'property': 'data-value',
					'size': 'absolute',
					'animate': true,
					'type': 'horisontal',
					'duration': 1000,
					'equal_speed': false
				}, _defineProperty(_ref, 'size', 'relative'), _defineProperty(_ref, 'transition', Fx.Transitions.linear), _ref));
			}
		}

		var _tbody;

		if (_divtable) {
			_tbody = _divtable.getElement('.tbody');
		}

		if (_tbody) {
			__zebring(_tbody.getElements('.tr:not(.hidden)'));

			var _filter = document.getElement('.filter');

			var filter_table = new FilterTable(_filter, { table: _divtable });

			filter_table.addEvent('endFilter', function (e) {
				__zebring(_tbody.getElements('.tr:not(.hidden)'));

				var _show_all = _filter.getElement('.show_all');
				_show_all.addClass('show');

				_show_all.addEvent('click', function () {
					var _bed = _filter.getElement('.w_styled_select');

					_bed.getElements('.option')[0].fireEvent('click');
					_show_all.removeClass('show');
				});
			});
		}

		this.bottom_bar();
		//this.add_alert_link();
		this.add_save_link();
		this.add_share_link();
		this.show_top_nav_contact();
		this.building_stalker_data();
	},
	building_stalker_data: function building_stalker_data() {
		var _info = document.getElement('.stalker_info');
		var building_stalker = document.getElement('.persist_nav.building');
		var building_name = _info.getElement('input[name="build_name"]').value;
		var building_address = _info.getElement('input[name="build_address"]').value;

		// Doorman?
		var is_doorman = _info.getElement('input[name="is_doorman"]').value;

		// Sales history removal
		var is_sales_history = _info.getElement('input[name="is_sales_history"]').value;
		if (!is_sales_history) {
			building_stalker.getElement('.sale-history').remove();
		}

		// Ratings removal
		var is_ratings = _info.getElement('input[name="is_ratings"]').value;
		if (!is_ratings) {
			building_stalker.getElement('.ratings').remove();
		}

		var build_type = _info.getElement('input[name=build_type]').value.capitalize();
		var build_hood = _info.getElement('input[name=map_name]').value;
		if (building_name) {
			building_stalker.getElement('.title').set('text', building_name + ', ' + building_address);
		} else {
			building_stalker.getElement('.title').set('text', building_address);
		}
		building_stalker.getElement('.bldg-type').set('text', (is_doorman ? 'Doorman ' : '') + build_type + ' in ' + build_hood);

		var apts_sale = document.getElement('input[name="apts_sale"]').value;
		var apts_rent = document.getElement('input[name="apts_rent"]').value;
		var apts_num = apts_sale + apts_rent;
	},

	show_top_nav_contact: function show_top_nav_contact() {
		var buttonContact = document.getElement('[data-popup-name="contact-popup"');
		var buttonContactTopNav = document.getElement('.button-contact-top');
		if (buttonContact && buttonContactTopNav) {
			buttonContactTopNav.removeClass('none');
		}
	},
	bottom_bar: function bottom_bar() {
		var triggerElement = document.getElement('.content');
		Core.bottom_bar(triggerElement, 150);
	},

	add_alert_link: function add_alert_link() {
		var _alertButton = document.getElement('.alert-button-container .building-alert');
		this._stalker_alert_link = document.getElement('.w_stalker .persist_nav.building .links-icons');
		if (this._stalker_alert_link && _alertButton) {
			_alertButton.inject(this._stalker_alert_link);
		}
	},

	add_save_link: function add_save_link() {
		var _alertButton = document.querySelector('.alert-button-container .building-alert2');
		this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .other-icons');
		if (this._stalker_alert_link && _alertButton) {
			var clonedAlertButton = _alertButton.cloneNode(true);
			this._stalker_alert_link.appendChild(clonedAlertButton);
		}
	},

	add_share_link: function add_share_link() {
		var _shareButton = document.querySelector('.alert-button-container .link-icon.email');
		this._stalker_alert_link = document.querySelector('.w_stalker .persist_nav.building .other-icons');
		if (this._stalker_alert_link && _shareButton) {
			var clonedShareButton = _shareButton.cloneNode(true);
			this._stalker_alert_link.appendChild(clonedShareButton);
		}
	},

	get_stalker_info: function get_stalker_info() {
		var _info = document.getElement('.stalker_info');

		this.apt_sale = _info.getElement('input[name=apts_sale]').get("value");
		this.apt_rent = _info.getElement('input[name=apts_rent]').get("value");
		this.build_name = _info.getElement('input[name=build_name]').get("value");
		this.build_address = _info.getElement('input[name=build_address]').get("value");
		this.build_type = _info.getElement('input[name=build_type]').get("value").capitalize();
		this.build_predev_concept = _info.getElement('input[name=build_predev_concept]').get("value");
		this.map_link = _info.getElement('input[name=map_link]').get("value");
		this.map_name = _info.getElement('input[name=map_name]').get("value");
		this.apt_sale_url = _info.getElement('input[name=apts_sale_url]').get("value");
		this.all_units_url = _info.getElement('input[name=all_units_url]').get("value");
		this.similar_buildings_url = _info.getElement('input[name=similar_buildings_url]').get("value");
		this.sales_history_url = _info.getElement('input[name=sales_history_url]').get("value");
		this.is_sales_history = _info.getElement('input[name=is_sales_history]').get("value");
		this.floorplans_url = _info.getElement('input[name=floorplans_url]') ? _info.getElement('input[name=floorplans_url]').get("value") : '';
		this.sell_url = _info.getElement('input[name=sell_url]') ? _info.getElement('input[name=sell_url]').get("value") : '';
		this.building_total_units = _info.getElement('input[name=building_total_units]') ? _info.getElement('input[name=building_total_units]').get("value") : '0';
	},

	fill_nav_title: function fill_nav_title() {
		var _stalker_title = document.getElement('.w_stalker .nav_title');

		var building_stalker = document.getElement('.persist_nav.building');
		var _info = document.getElement('.stalker_info');
		var is_doorman = _info.getElement('input[name="is_doorman"]').value;
		var build_type = _info.getElement('input[name=build_type]').value.capitalize();
		var build_hood = _info.getElement('input[name=map_name]').value;
		building_stalker.getElement('.bldg-type').set('text', (is_doorman ? 'Doorman ' : '') + build_type + ' in ' + build_hood);

		// links
		var navItems = document.querySelectorAll('.building_nav ul li');
		var bldgFullUrl = document.querySelector('input[name="bldg_full_url"]').value;

		navItems.forEach(function (item) {
			item.addEventListener('click', function () {
				var targetId = this.getAttribute('data-target');
				if (targetId) {
					var fullUrlWithHash = bldgFullUrl + '#' + targetId;
					// redirect to hash
					window.location.href = fullUrlWithHash;
				}
			});
		});

		if (!_stalker_title) {
			return;
		}

		var _stalker_info = _stalker_title.getElement('._info');
		var _stalker_build_type = _stalker_title.getElement('._type');
		// var _stalker_map_link = _stalker_title.getElement('._map');

		// var _stalker_build_name = _stalker_title.getElement('._name');
		// check the building name
		// if (this.build_name === ''){
		// 	this.build_name = this.build_address;
		// 	_stalker_build_name.set('text', this.build_name);
		// } else {
		// 	// check the address
		// 	if (this.build_address === '') {
		// 		_stalker_build_name.set('text', this.build_name);
		// 	} else {
		// 		_stalker_build_name.set('text', this.build_name + ', ' + this.build_address);
		// 	}
		// }

		var buildingTypeAndHood = void 0;
		if (this.build_type != '') {
			buildingTypeAndHood = this.build_type;
		}
		if (this.map_name != '') {
			if (this.build_type != '') {
				buildingTypeAndHood += ' in ';
			}
			buildingTypeAndHood += this.map_name;
		}
		_stalker_build_type.set('text', buildingTypeAndHood);
	},

	set_off_market_deals: function set_off_market_deals() {
		var _off_market_deals = document.getElement('.w_stalker ._info .button-off-market-deals');

		if (_off_market_deals) {
			if (this.build_predev_concept == "0" && (this.build_type === 'Condo' || this.build_type === 'Co-Op' || this.build_type === 'Condop')) {
				// nothing to do
			} else {
				_off_market_deals.getParent().dispose();
			}
		}
	},

	set_available_apts: function set_available_apts() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _aval_apts = document.getElement('.w_stalker ._info ._aval_apts');

		if (apts > 0 && _aval_apts && _aval_apts.getElement('._value')) {
			_aval_apts.getElement('._value').set('text', apts);
			_aval_apts.getElement('._text').set('text', 'Available Apt' + (apts > 1 ? 's' : ''));
			_aval_apts.set('href', this.apt_sale_url);
		} else if (_aval_apts) {
			_aval_apts.getParent().dispose();
		}
	},

	set_sales_data: function set_sales_data() {
		var _sales_history = document.getElement('.w_stalker ._info ._sales_history');

		if (_sales_history && this.is_sales_history === '1') {
			_sales_history.set('href', this.sales_history_url);
		} else if (_sales_history) {
			_sales_history.getParent().dispose();
		}
	},

	set_similar_buildings: function set_similar_buildings() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _similar_buildings = document.getElement('.w_stalker ._info ._similar_buildings');

		if (_similar_buildings) {
			_similar_buildings.set('href', this.similar_buildings_url);
		} else if (_similar_buildings) {
			_similar_buildings.getParent().dispose();
		}
	},

	set_all_units: function set_all_units() {
		var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
		var _all_units = document.getElement('.w_stalker ._info ._all_units');

		if (_all_units && this.all_units_url && this.build_predev_concept == "0") {
			_all_units.set('href', this.all_units_url);
		} else if (_all_units) {
			_all_units.getParent().dispose();
		}
	},

	// set_floorplans: function() {
	// 	var apts = this.apt_sale.toInt() + this.apt_rent.toInt();
	// 	var _floorplans = document.getElement('.w_stalker ._info ._floorplans');

	// 	if (_floorplans && this.floorplans_url) {
	// 		_floorplans.set('href', this.floorplans_url);
	// 	} else {
	// 		_floorplans.getParent().dispose();
	// 	}
	// }, 

	set_sell: function set_sell() {
		var _sell = document.getElement('.w_stalker ._info ._sell');

		if (_sell) {
			if (_sell && this.sell_url && this.build_type !== 'No Fee Rental' && this.build_type !== 'Townhouse') {
				_sell.set('href', this.sell_url);
				Core.setBuildingSellData(_sell, this.building_total_units);
			} else {
				_sell.getParent().dispose();
			}
		}
	},

	set_contact: function set_contact() {
		var _contact = document.getElement('.w_stalker ._info .button-book-tour');

		if (_contact && this.build_type === 'No Fee Rental') {
			_contact.set('text', 'Contact');
		}
	}
});
//# sourceMappingURL=bsr.js.map
